import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../core/config/app.config';
import { Observable } from 'rxjs';
import { ProjectEventModel } from './project-event.model';
import { IProjectEventsResponse } from './project-events-response.interface';
import { IEventGroup } from './event.model';
import { IGenerateEvents } from './generate-events.interface';

@Injectable({ providedIn: 'root' })
export class EventService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);


  updateProjectEvent(projectEvent: ProjectEventModel) {
    return this.http.put(this.config.buildUri('projectEvent') + '/UpdateProjectEventAndEvent', projectEvent);
  }

  updateProjectEvents(projectEvent: ProjectEventModel[]): Observable<ProjectEventModel[]> {
    return this.http.put<ProjectEventModel[]>(this.config.buildUri('projectEvent') + '/UpdateProjectEventsAndEvents', projectEvent);
  }

  createProjectEvent(projectEvent: ProjectEventModel) {
    const projectEventBody = { ...projectEvent };
    delete projectEventBody.id;
    delete projectEventBody.eventId;
    delete projectEventBody.orderPriority; // TODO: remove when priority requerments are completed
    delete projectEventBody.project;
    delete projectEventBody.event.id;

    return this.http.post(
      this.config.buildUri('projectEvent') + '/CreateProjectEventAndEvent?isAmend=false',
      projectEventBody,
    );
  }

  deleteProjectEvent(id: number): Observable<any> {
    return this.http.delete(this.config.buildUri('projectEvent') + '/ProjectEvent/?projectEventId=' + id);
  }

  _getProjectEventListByProjectId(id: number): Observable<ProjectEventModel[]> {
    return this.http.get<ProjectEventModel[]>(this.config.buildUri('projectEvent') + `/GetProjectEventsByProjectId?projectId=${id}`);
  }
  getProjectEventListByProjectId(id: number): Observable<IProjectEventsResponse> {
    return this.http.get<IProjectEventsResponse>(this.config.buildUri('projectEvent') + `/GetEventsGrid?projectId=${id}`);
  }

  getProjectEventsCommentsCounters(projectId: number): Observable<any[]> {
    return this.http.get<any[]>(
      this.config.buildUri('projectEventComments') + `/ProjectEventCommentCount?projectId=${projectId}`,
    );
  }

  createEventGroup(data: Pick<IEventGroup, 'name' | 'projectId'>): Observable<IEventGroup> {
    return this.http.post<IEventGroup>(`${this.config.buildUri('eventGroup')}/CreateEventGroup`, data);
  }

  updateEventGroup(data: IEventGroup): Observable<IEventGroup> {
    return this.http.put<IEventGroup>(`${this.config.buildUri('eventGroup')}/RenameEventGroup`, data);
  }

  deleteEventGroup(data: { projectId: number; groupId: number }): Observable<unknown> {
    return this.http.delete<unknown>(`${this.config.buildUri('eventGroup')}/DeleteEventGroup`, { body: data });
  }

  softDeleteEventGroup(data: { projectId: number; groupId: number }): Observable<unknown> {
    return this.http.post<unknown>(`${this.config.buildUri('eventGroup')}/SoftDeleteEventGroup`, data);
  }

  generateEventsInGroup(payload: IGenerateEvents): Observable<IGenerateEvents> {
    return this.http.post<IGenerateEvents>(`${this.config.buildUri('projectEvent')}/GenerateEventsInGroup`, payload);
  }
}
